import { Rpc } from "rpc/rpc";


export class WorkDaysRpc {

    public static list(): Promise<ListWorkDaysResp> {
        return Rpc.GET("/rpc/settings/workdays/list");
    }

    public static save(req: SaveWorkDaysReq): Promise<void> {
        return Rpc.POST("/rpc/settings/workdays/save", req);
    }

    private constructor() {}

}

export class ListWorkDaysResp {

    public workDays: boolean[];

}

export class SaveWorkDaysReq {

    public workDays: boolean[];

}